import React from 'react';

interface LogoProps {
  isCollapsed?: boolean;
  alwaysDark?: boolean;
}

const Logo: React.FC<LogoProps> = ({ isCollapsed = false, alwaysDark = false }) => {
  return (
    <div className={`flex items-center ${isCollapsed ? 'justify-center' : ''}`}>
      {/* Placeholder blue rectangle for logo */}
      {/* <div className="w-10 h-10 bg-primary rounded-md flex-shrink-0"></div> */}
      <img src='/maersk.png' alt="Maersk Logo" className='w-10 h-10'></img>
      
      {!isCollapsed && (
        <div className="ml-3">
          <h1 className="text-lg flex items-center">
            <span className="font-bold text-primary mr-1">Shipment</span>
            <span className={`font-light ${alwaysDark ? 'text-white' : 'text-text-primary dark:text-white'}`}>CoCaptain</span>
          </h1>
        </div>
      )}
    </div>
  );
};

export default Logo;